<template>
  <b-tab
    title="Informações da venda"
    :active="isTheCurrentTab"
    :disabled="!isTheCurrentTab && !store.isUpdate"
    class="w-75"
    @click="() => (store.currentTab = 3)"
  >
    <b-row>
      <b-col sm="4">
        <label>Término da recorrência</label>
        <b-form-group label-for="tempo_contrato">
          <b-form-select
            id="tempo_contrato"
            v-model="form.termino_recorrencia"
            :options="tempo_contrato"
          />
        </b-form-group>
      </b-col>
      <b-col sm="3" v-if="isPeriodoEspecifico">
        <label for="data_inicio">Início da vigência</label>
        <b-form-group>
          <b-form-datepicker
            id="data_inicio"
            v-model="form.data_inicio"
            locale="pt-br"
          />
        </b-form-group>
      </b-col>
      <b-col sm="3" v-if="isPeriodoEspecifico">
        <label for="data_termino">Término da vigência</label>
        <b-form-group>
          <b-form-datepicker
            id="data_termino"
            v-model="form.data_termino"
            locale="pt-br"
            :min="form.data_inicio || undefined"
          />
        </b-form-group>
      </b-col>
      <b-col sm="2" v-if="isPeriodoEspecifico">
        <label>Vigência total</label>
        <b-form-group>
          <b-badge variant="primary" pill> {{ vigenciaTotal }} meses </b-badge>
        </b-form-group>
      </b-col>
    </b-row>
    <hr />

    <b-row>
      <b-col md="8">
        <label>E-mail para receber fatura: </label>
        <b-form-group
          id="data_termino"
          label-for="E-mail para receber fatura: "
        >
          <b-form-input
            id="email_fatura"
            type="email"
            v-model="form.email_fatura"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="!store.formFaturamento.cobranca_anual">
      <b-col md="4">
        <label>Emitir NFSe</label>
        <span class="switch switch-icon">
          <label v-b-tooltip.hover.right="'Não/Sim'">
            <input type="checkbox" v-model="form.emitir_nfse" />
            <span></span>
          </label>
        </span>
      </b-col>
      <b-col md="4">
        <label>Emitir Boletos</label>
        <span class="switch switch-icon">
          <label v-b-tooltip.hover.right="'Não/Sim'">
            <input
              type="checkbox"
              v-model="form.emitir_boletos"
              :disabled="!canGenerateBoleto"
            />
            <span></span>
          </label>
        </span>
        <small v-if="!canGenerateBoleto" class="text-muted d-block mt-1">
          Configure uma integração de boleto nas contas bancárias para gerar
          boletos.
        </small>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col md="6">
        <b-form-group label="Status" label-for="status">
          <VueSelect
            ref="buscarStatus"
            :filterable="false"
            @input="setStatus"
            :options="allStatus"
            v-model="form.status"
          >
            <template slot="no-options"> Informe o status </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.descricao }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.descricao }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group label="Vendedor" label-for="vendedor">
          <VueSelect
            ref="buscaVendedor"
            :filterable="false"
            @input="setVendedor"
            :options="vendedores"
            v-model="vendedor"
            @open="onSearchVendedor"
            @search="onSearchVendedor"
          >
            <template slot="no-options"> Informe o nome do vendedor </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.nome }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.nome }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="!store.formFaturamento.cobranca_anual">
      <!-- Aqui aparece o aviso -->
      <b-col>
        <b-alert
          v-if="isAtivoSelecionado"
          variant="primary"
          show
          class="mt-2 d-flex align-items-start"
        >
          <div class="mr-2">
            <i class="la la-info-circle" style="font-size: 1.25rem"></i>
          </div>
          <div>
            <div class="font-weight-bold mb-1">
              Ao ativar o contrato, o sistema irá iniciar as automações de
              faturamento:
            </div>

            <ul class="mb-1 pl-3">
              <li v-if="form.emitir_nfse">
                <i class="la la-file-invoice mr-1"></i>
                Emitir <strong>NFSe</strong> conforme os serviços configurados.
              </li>
              <li v-if="form.emitir_boletos">
                <i class="la la-barcode mr-1"></i>
                Gerar <strong>boletos</strong> com vencimento no dia
                <strong>{{ store.formFaturamento.dia_cobranca || "—" }}</strong>
                do mês.
              </li>
              <li
                v-if="
                  currentEmpresaId !== 1 &&
                  (form.emitir_nfse || form.emitir_boletos)
                "
              >
                <i class="la la-envelope mr-1"></i>
                Processar faturamento e envio no dia
                <strong>{{ store.formFaturamento.dia_envio_fatura || 1 }}</strong>
                do mês.
              </li>
              <li
                v-if="!form.emitir_nfse && !form.emitir_boletos"
                class="text-muted"
              >
                Nenhuma automação marcada. Ative “Emitir NFSe” e/ou “Emitir
                Boletos” acima.
              </li>
            </ul>

            <small class="text-muted">
              Você pode alterar essas opções antes de salvar:
              <em>Emitir NFSe</em>, <em>Emitir Boletos</em> e
              <em>Dia da Cobrança</em><span v-if="currentEmpresaId !== 1">
                e <em>Dia de Envio</em></span
              >.
            </small>
          </div>
        </b-alert>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col class="">
        <b-form-group label="Informações Adicionais" label-for="observacao">
          <v-textarea
            full-width
            no-resize
            rows="1"
            auto-grow
            v-model="form.observacao"
          ></v-textarea>
        </b-form-group>
      </b-col>
    </b-row>
  </b-tab>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { store } from "../../storeContratos";
import InformacoesData from "../InformacoesData";
import { isBoletoApiAtiva } from "@/core/utils/sicoob";
import { calcularVigenciaMeses } from "../../contractValue";

export default {
  name: "app-contrato-form-informacoesTab",
  components: {
    VueSelect,
  },
  directives: {
    mask,
  },
  data() {
    return {
      form: {},
      allStatus: [
        {
          id: 1,
          descricao: "Editando",
        },
        {
          id: 2,
          descricao: "Ativo",
        },
      ],
      status: null,
      keyToReRender: 0,
      store,
      statusError: false,
      enderecoError: false,
      statusFilled: false,
      tempo_contrato: [
        {
          value: 1,
          text: "Em um período específico",
        },
        {
          value: 2,
          text: "Indeterminado",
        },
      ],
      vendedores: [],
      vendedor: null,
      contasBancarias: [],
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      try {
        const contasBancarias = await this.getBancosByEmpresa();
        this.contasBancarias = Array.isArray(contasBancarias)
          ? contasBancarias
          : [];
      } catch (error) {
        this.contasBancarias = [];
      }

      this.form = new InformacoesData({});
      this.form.status = this.allStatus.find((item) => item.id === 1);
      this.form.data_venda = this.thisDate();
      this.form.data_inicio = this.thisDate();
      this.form.data_termino = this.afterYear();
      this.form.emitir_nfse = false;
      this.form.emitir_boletos = false;
      this.form.termino_recorrencia = 1;

      if (Object.keys(this.$route.params).length !== 0) {
        const {
          emitir_nfse,
          emitir_boletos,
          data_inicio,
          data_termino,
          observacao,
          status: statusId,
          email_fatura,
          renovacao_automatica,
          termino_recorrencia,
          vendedor,
          data_venda,
        } = this.$route.params.contratoData;

        this.form.data_venda = data_venda;
        this.form.emitir_boletos = emitir_boletos;
        this.form.emitir_nfse = emitir_nfse;
        this.form.observacao = observacao;
        this.form.data_inicio = data_inicio;
        this.form.data_termino = data_termino;
        this.form.email_fatura = email_fatura;
        this.form.renovacao_automatica = renovacao_automatica;
        this.form.termino_recorrencia = Number(termino_recorrencia) || 1;
        this.form.status = this.allStatus.find((s) => s.id === statusId);

        if (vendedor) {
          this.setVendedor(vendedor);
          this.vendedor = vendedor;
        }
      } else {
        this.vendedor = null;

        if (this.vendedorLogado?.id_vendedor) {
          this.vendedor = this.vendedorLogado;
          this.setVendedor(this.vendedor);
        }
      }
    },

    setStatus(status) {
      this.form.status = status;
      this.statusFilled = true;
    },
    setVendedor(vendedor) {
      this.form.id_vendedor = vendedor?.id_vendedor || null;
    },
    calcularVigenciaMeses(dataInicio, dataTermino) {
      return calcularVigenciaMeses(dataInicio, dataTermino);
    },
    onSearchVendedor(search, loading) {
      const busca = this.prepararBuscaDireta(search, loading);
      busca.loading(true);
      this.searchVendedor(busca.loading, busca.termo, this);
    },
    searchVendedor: _.debounce(async (loading, search, vm) => {
      vm.vendedores = await vm.getVendedorByNome(search);
      if (loading) loading(false);
    }, 350),
  },
  async created() {
    await this.getDataInit();
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "nutsDigital",
    ]),
    ...mapState(["loading"]),
    ...mapState({
      vendedorLogado: (state) => state.auth.vendedor,
      currentUser: (state) => state.auth.user,
    }),
    currentEmpresaId() {
      return Number(this.currentUser?.usuario_empresa?.id_empresa ?? 0);
    },
    temSicoobApi() {
      return this.contasBancarias?.some(isBoletoApiAtiva) ?? false;
    },
    canGenerateBoleto() {
      return Boolean(this.nutsDigital || this.temSicoobApi);
    },
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === 3;
    },
    isPeriodoEspecifico() {
      return Number(this.form.termino_recorrencia) === 1;
    },
    vigenciaTotal() {
      return this.calcularVigenciaMeses(
        this.form.data_inicio,
        this.form.data_termino
      );
    },
    isAtivoSelecionado() {
      const s = this.form?.status;
      if (!s) return false;

      // funciona tanto por id quanto pela descrição
      const desc = (s.descricao || "").toLowerCase();
      return (
        s.id === 4 || // se você tiver um ID específico para "Ativo"
        desc.includes("ativo")
      ); // ou identifica pelo texto
    },
  },
  watch: {
    "store.formInformacoes"(newValue, oldValue) {
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        this.keyToReRender++;
      }
    },
    form(newValue) {
      this.store.formInformacoes = newValue;
    },
  },
};
</script>
